import { createStore } from 'vuex';
import { createI18n } from 'vue-i18n';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons/faFileExcel';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faIdCard } from '@fortawesome/free-solid-svg-icons/faIdCard';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faPhotoVideo } from '@fortawesome/free-solid-svg-icons/faPhotoVideo';
import { faStore } from '@fortawesome/free-solid-svg-icons/faStore';
import { faTabletAlt } from '@fortawesome/free-solid-svg-icons/faTabletAlt';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faUnlock } from '@fortawesome/free-solid-svg-icons/faUnlock';
import { faUserEdit } from '@fortawesome/free-solid-svg-icons/faUserEdit';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons/faEuroSign';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons/faExchangeAlt';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';
import { faCubes } from '@fortawesome/free-solid-svg-icons/faCubes';
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons/faLayerGroup';
import { faLevelUpAlt } from '@fortawesome/free-solid-svg-icons/faLevelUpAlt';
import { faPercent } from '@fortawesome/free-solid-svg-icons/faPercent';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faBatteryFull } from '@fortawesome/free-solid-svg-icons/faBatteryFull';
import { faBatteryThreeQuarters } from '@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters';
import { faBatteryHalf } from '@fortawesome/free-solid-svg-icons/faBatteryHalf';
import { faBatteryQuarter } from '@fortawesome/free-solid-svg-icons/faBatteryQuarter';
import { faBatteryEmpty } from '@fortawesome/free-solid-svg-icons/faBatteryEmpty';
import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt';
// Mise à jour de l'app à distance : menu « Versions de l'app », diffusion, retrait d'une cible.
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faEraser } from '@fortawesome/free-solid-svg-icons/faEraser';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faHourglass } from '@fortawesome/free-solid-svg-icons/faHourglass';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';

import { accountStore } from '@/shared/config/store/account-store';
import { translationStore } from '@/shared/config/store/translation-store';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag';
import { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils';

const dateTimeFormats = {
  fr: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
    medium: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  // jhipster-needle-i18n-language-date-time-format - JHipster will add/remove format options in this object
};

export function initFortAwesome() {
  library.add(
    faArrowLeft,
    faTable,
    faShoppingBag,
    faUtensils,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faExclamationCircle,
    faExclamationTriangle,
    faFileExcel,
    faFilter,
    faFolder,
    faGlobe,
    faIdCard,
    faImage,
    faKey,
    faLink,
    faPhotoVideo,
    faStore,
    faTabletAlt,
    faTag,
    faUnlock,
    faUserEdit,
    faAsterisk,
    faBan,
    faBars,
    faBell,
    faBook,
    faClock,
    faClone,
    faCopy,
    faCloud,
    faCogs,
    faDatabase,
    faEye,
    faFlag,
    faHeart,
    faHome,
    faHourglass,
    faList,
    faLock,
    faPencilAlt,
    faPlus,
    faPrint,
    faRoad,
    faSave,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faSort,
    faSortDown,
    faSortUp,
    faSync,
    faTachometerAlt,
    faTasks,
    faThList,
    faTimes,
    faTimesCircle,
    faTrash,
    faUser,
    faUserPlus,
    faUsers,
    faUsersCog,
    faWrench,
    faCheck,
    faUpload,
    faDownload,
    faCalendarAlt,
    faChartBar,
    faEuroSign,
    faListUl,
    faExchangeAlt,
    faInfoCircle,
    faShoppingCart,
    faUserTie,
    faCreditCard,
    faCubes,
    faDesktop,
    faHistory,
    faLayerGroup,
    faLevelUpAlt,
    faPercent,
    faMapMarkerAlt,
    faQuestionCircle,
    faEnvelope,
    faRedo,
    faBatteryFull,
    faBatteryThreeQuarters,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryEmpty,
    faBolt,
    faMobileAlt,
    faPaperPlane,
    faEraser
  );
}

export function initI18N() {
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'fr',
    fallbackLocale: 'fr',
    datetimeFormats: dateTimeFormats,
    // Les messages sont chargés paresseusement par TranslationService (setLocaleMessage).
    missingWarn: false,
    fallbackWarn: false,
  });
}

export function initVueXStore() {
  return createStore({
    modules: {
      accountStore,
      translationStore,
    },
  });
}
